import React, { useEffect, useState } from 'react';
import { Plus, RefreshCw, Edit, Trash2 } from 'lucide-react';
import { API_URLS } from '../../../config/api';
import { adminApiFetch } from '../../../utils/adminApi';

export default function AdminMarkaTescilClasses() {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [editingClass, setEditingClass] = useState(null);
  const [editForm, setEditForm] = useState({ name: '', kurum_harc: '', hizmet_bedeli: '' });

  const fetchClasses = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await adminApiFetch(API_URLS.ADMIN.MARKA_TESCIL.CLASSES);
      const data = await res.json();
      setClasses(Array.isArray(data?.data) ? data.data : []);
    } catch (e) {
      setError('Sınıflar yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (cls) => {
    setEditingClass(cls);
    setEditForm({
      name: cls.name.replace(/^\d+\s*-\s*/, ''),
      kurum_harc: cls.kurum_harc || 480,
      hizmet_bedeli: cls.hizmet_bedeli || 1490
    });
  };

  const handleSave = async () => {
    try {
      const res = await adminApiFetch(API_URLS.ADMIN.MARKA_TESCIL.UPDATE_CLASS(editingClass.id), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editForm)
      });
      const data = await res.json();
      if (data.status === 'success') {
        setEditingClass(null);
        fetchClasses();
      } else {
        setError(data.message || 'Güncelleme başarısız');
      }
    } catch (e) {
      setError('Güncelleme başarısız');
    }
  };

  const handleDelete = async (id) => {
    if (!confirm('Bu sınıfı silmek istediğinizden emin misiniz?')) return;
    try {
      const res = await adminApiFetch(API_URLS.ADMIN.MARKA_TESCIL.DELETE_CLASS(id), { method: 'DELETE' });
      const data = await res.json();
      if (data.status === 'success') {
        fetchClasses();
      } else {
        setError(data.message || 'Silme başarısız');
      }
    } catch (e) {
      setError('Silme başarısız');
    }
  };

  useEffect(() => {
    fetchClasses();
  }, []);

  return (
    <div className="px-2 sm:px-0">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-0 mb-4 sm:mb-6">
        <h2 className="text-lg sm:text-xl font-bold">Marka Tescil Sınıfları</h2>
        <div className="flex items-center gap-2 w-full sm:w-auto">
          <button onClick={fetchClasses} className="h-9 px-3 rounded-md border border-gray-200 hover:bg-gray-50 text-xs sm:text-sm flex items-center gap-2 flex-1 sm:flex-initial justify-center"><RefreshCw className="w-4 h-4" /> <span className="hidden sm:inline">Yenile</span></button>
          <button className="h-9 px-3 rounded-md bg-purple-600 hover:bg-purple-700 text-white text-xs sm:text-sm flex items-center gap-2 flex-1 sm:flex-initial justify-center"><Plus className="w-4 h-4" /> <span className="hidden sm:inline">Yeni Sınıf</span></button>
        </div>
      </div>

      {error && <div className="mb-4 text-xs sm:text-sm text-red-600">{error}</div>}

      <div className="border border-gray-100 rounded-xl overflow-hidden">
        <div className="grid grid-cols-12 bg-gray-50 text-xs sm:text-sm font-semibold text-gray-700 px-3 sm:px-4 py-3 sm:py-2 gap-2">
          <div className="col-span-2">Kod</div>
          <div className="col-span-4">Ad</div>
          <div className="col-span-2">Kurum Harcı</div>
          <div className="col-span-2">Hizmet Bedeli</div>
          <div className="col-span-2 text-right">İşlemler</div>
        </div>
        {loading ? (
          <div className="p-6 text-sm text-gray-500">Yükleniyor...</div>
        ) : classes.length === 0 ? (
          <div className="p-6 text-sm text-gray-500">Kayıt bulunamadı.</div>
        ) : (
          classes.map((c, i) => (
            <div key={i} className="grid grid-cols-12 items-center px-3 sm:px-4 py-4 sm:py-3 border-t text-xs sm:text-sm gap-2">
              <div className="col-span-2 font-mono">{c.code}</div>
              <div className="col-span-4 break-words">{c.name}</div>
              <div className="col-span-2 whitespace-nowrap">{c.kurum_harc ? `₺${parseFloat(c.kurum_harc).toLocaleString('tr-TR', {minimumFractionDigits: 2})}` : '-'}</div>
              <div className="col-span-2 whitespace-nowrap">{c.hizmet_bedeli ? `₺${parseFloat(c.hizmet_bedeli).toLocaleString('tr-TR', {minimumFractionDigits: 2})}` : '-'}</div>
              <div className="col-span-2 text-right flex flex-col sm:flex-row items-end sm:items-center justify-end gap-1 sm:gap-2">
                <button onClick={() => handleEdit(c)} className="p-1.5 sm:p-1 text-blue-600 hover:bg-blue-50 rounded"><Edit className="w-4 h-4" /></button>
                <button onClick={() => handleDelete(c.id)} className="p-1.5 sm:p-1 text-red-600 hover:bg-red-50 rounded"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Edit Modal */}
      {editingClass && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/50" onClick={() => setEditingClass(null)} />
          <div className="relative bg-white w-full max-w-md rounded-xl shadow-xl border border-gray-100 max-h-[90vh] overflow-y-auto">
            <div className="px-4 sm:px-6 py-3 sm:py-4 border-b sticky top-0 bg-white">
              <h3 className="text-base sm:text-lg font-bold">Sınıf Düzenle</h3>
            </div>
            <div className="p-4 sm:p-6 space-y-4">
              <div>
                <label className="text-xs sm:text-sm text-gray-700">Sınıf Adı</label>
                <input
                  value={editForm.name}
                  onChange={(e) => setEditForm({...editForm, name: e.target.value})}
                  className="mt-1 w-full h-10 text-sm sm:text-base border border-gray-200 rounded-lg px-3"
                />
              </div>
              <div>
                <label className="text-xs sm:text-sm text-gray-700">Kurum Harcı (₺)</label>
                <input
                  type="number"
                  step="0.01"
                  value={editForm.kurum_harc}
                  onChange={(e) => setEditForm({...editForm, kurum_harc: e.target.value})}
                  className="mt-1 w-full h-10 text-sm sm:text-base border border-gray-200 rounded-lg px-3"
                />
              </div>
              <div>
                <label className="text-xs sm:text-sm text-gray-700">Hizmet Bedeli (₺)</label>
                <input
                  type="number"
                  step="0.01"
                  value={editForm.hizmet_bedeli}
                  onChange={(e) => setEditForm({...editForm, hizmet_bedeli: e.target.value})}
                  className="mt-1 w-full h-10 text-sm sm:text-base border border-gray-200 rounded-lg px-3"
                />
              </div>
            </div>
            <div className="px-4 sm:px-6 py-3 sm:py-4 border-t flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-2 sm:gap-3 sticky bottom-0 bg-white">
              <button onClick={() => setEditingClass(null)} className="h-10 px-4 rounded-md border border-gray-200 text-sm sm:text-base">İptal</button>
              <button onClick={handleSave} className="h-10 px-4 rounded-md bg-blue-600 hover:bg-blue-700 text-white font-medium text-sm sm:text-base">Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


